<template>
    <div id="app">
        <template v-if="isRouterAlive">
            <keep-alive>
                <router-view v-if="keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!keepAlive"></router-view>
        </template>
    </div>
</template>
<script>
//首页引入base.scss
import 'ASSETS/scss/common/base.scss'

export default {
    provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
        return {
            reload: this.reload
        }
    },
    data () {
        return {
            isRouterAlive: false,
        }
    },
    computed: {
        keepAlive () {
            return this.$route.meta.keepAlive
        }
    },
    methods: {
        reload () {
            this.isRouterAlive = false;            //先关闭，
            this.$nextTick(function () {
                this.isRouterAlive = true;         //再打开
            })
        }
    },
    async created () {
        if (location.href.indexOf("/login") == -1 && location.href.indexOf("/devlogin") == -1 && location.href.indexOf("/zxez_login") == -1) {
            this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
                if (res.data.response === 'ok') {
                    let r = res.data.data;
                    localStorage.setItem('info', JSON.stringify(r));
                    if (r.units.length) {
                        if (r.units[0].city_id == "411600") {
                            localStorage.setItem('city_id', "411600");
                        } else {
                            localStorage.setItem('city_id', "");
                        }
                    }
                }
            }).finally(()=>{this.isRouterAlive = true;})
        } else {
            this.isRouterAlive = true;
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
